import { apiClient } from "..";
import type { AuthLoginRequest, AuthLoginResponse } from "../types/auth";

export class AuthService {
  static async login(payload: AuthLoginRequest): Promise<AuthLoginResponse> {
    return apiClient.post<AuthLoginResponse>("/auth/login", payload);
  }
}


